module.exports = __webpack_public_path__ + "static/media/icon_error.9878c269.svg";